const MEIO = {
    DOC: { id: 'DOC', descricao: 'DOC' },
    TED: { id: 'TED', descricao: 'TED' },
    PIX: { id: 'PIX', descricao: 'PIX' },
    DIR: { id: 'DIR', descricao: 'Direta' },
    CAR: { id: 'CAR', descricao: 'Cartão' },
    BOL: { id: 'BOL', descricao: 'Boleto' },
    DEB: { id: 'DEB', descricao: 'Débito' },
    PAP: { id: 'PAP', descricao: 'Papel Moeda' },
    OF: { id: 'OF', descricao: 'Open Finance' }
};

module.exports = MEIO;
